import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import useRecruiterDashboard from './useRecruiterDashboard';
import BarChartCommonComponent from '../../../../library/SimpleControls/BarChartCommonComponent';

const TypeOfRecruiters = () => {
    const { state } = useContext(SmartContext);
    const { getTypeOfRecruiters } = useRecruiterDashboard();

    useEffect(() => {
        getTypeOfRecruiters();
    }, [state.data.searchCriteria.typeOfRecruiters]);

    if (isEmpty(state.data?.reportData?.typeOfRecruiters))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <BarChartCommonComponent data={state.data.reportData.typeOfRecruiters} />
        </>
    );
};

export default TypeOfRecruiters;
